import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";






const STRINGS = {
  NO_card_JCR_ERROR: 'No card JCR objects provided to helper-card.',
  NO_card_CONTENT_ERROR: '<strong>Error:</strong> No card content available.',
  DEFAULT_ADA_ERROR_TEXT: ', contains an error message',
  DEFAULT_ADA_WARNING_TEXT: ', contains an warning message',
  DEFAULT_ADA_SUCCESS_TEXT: ', contains a success message',
};

const allowedTitleTags = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'p',
  'div',
];









function getDynamicContent(card, contexts, template) {
  let cardContent;
  let cardContext;


  contexts.forEach((context) => {
    if (card.content === context.jcr) {
      cardContext = context;
    }
  });


  if (contexts.length > 0) {
    cardContext = contexts[0];
  } else {
    cardContext = contexts;
  }


  if (contexts && contexts.length > 0) {

    if (card.dynamicContent === 'partial') {
      cardContent = template(cardContext);
    } else if (card.dynamicContent === 'markdown') { 
      cardContent = template({
        content: cardContext,
      });
    } else { 
      cardContent = card.content;
    }
  } else { 
    cardContent = card.content || 'No card content found';
  }


  return cardContent;
}








function createCard(jcr, args) {
  if (!jcr) {
    throw new Error(STRINGS.NO_card_JCR_ERROR);
  }


  const jcrContexts = Array.prototype.slice.call(args, 0, -1);



  const options = jcr;
  const settings = new (function SettingsContructor() {

    this.debug = !!options.debug;
    this.getID = options.id;


    this.id = this.getID ? `id='${this.getID.toLowerCase()}'` : '';
    this.caret = options.caret ? `card-caret-${options.caret}` : '';
    this.class = options.class
      ? `class="spa-card spa-card--medium spa-card--overlay ${this.caret} ${options.class}"`
      : `class="spa-card spa-card--medium spa-card--overlay ${this.caret}"`;


    this.title = options.title ? options.title : null;
    this.titleTag = (options.titleTag && allowedTitleTags.indexOf(options.titleTag) >= 0)
      ? options.titleTag
      : 'div';


    this.dismissible = !!options.dismissible;
    this.dismissibleADA = options.dismissibleADA;
    this.dismissibleADA = this.dismissibleADA === false ? 'Close Card' : this.dismissibleADA;
    this.dismissibleDescribedBy = options.dismissibleDescribedBy || '';
    this.dismissibleClass = options.dismissibleClass;

    this.layerStartADA = options.layerStartADA
      ? options.layerStartADA
      : false;

    this.layerStartADAShowFocus = options.layerStartADAShowFocus
      ? 'show-on-focus'
      : '';

    this.layerEndADA = options.layerEndADA
      ? options.layerEndADA
      : false;

    this.layerEndADAShowFocus = options.layerEndADAShowFocus
      ? 'show-on-focus'
      : '';


    this.config = options.config;
    this.titleID = this.config && this.config.titleID
      ? this.config.titleID
      : '';

    this.bodyID = this.config && this.config.bodyID
      ? this.config.bodyID
      : '';


    this.card = options.markup;
    this.cardContent = (options.markup && options.markup.content)
      ? jcr.markup.content
      : null;

    this.dynamicContent = (options.markup && options.markup.dynamicContent)
      ? options.markup.dynamicContent
      : null;

    this.partialName = (options.markup && options.markup.partialName)
      ? options.markup.partialName
      : null;

    this.templateString = this.dynamicContent;


    this.header = options.head || '';
    this.headerClass = this.header.class || '';
    this.headerTitleClass = this.header.titleClass || '';
    this.headerSkin = options.skin
      ? `spa-card__head-wrapper-${options.skin}`
      : '';

    this.headerIcon = (options.skin === 'red' || options.skin === 'blue')
      ? 'spa-card__dismissible-white'
      : '';


    this.footer = options.foot || '';
    this.footerConfig = this.footer.config || {};
    this.footerData = this.footer.data || [];


    this.footerLayoutClass = this.footerConfig.layout || '';
    this.footerLayoutDataAttr = this.footerConfig.layout ? `data-layout="${this.footerConfig.layout}"` : '';
    this.footerStackedDesktop = this.footerConfig.stackOnDesktop ? `data-stacked-desktop="${this.footerConfig.stackOnDesktop}"` : '';
    this.footerStackedTablet = this.footerConfig.stackOnTablet ? `data-stacked-tablet="${this.footerConfig.stackOnTablet}"` : '';
    this.footerStackedMobile = this.footerConfig.stackOnMobile === false ? `data-stacked-mobile="${this.footerConfig.stackOnMobile}"` : 'data-stacked-mobile="true"';


    this.partials = new (function PartialsContructor() {

      this.cardWrapper = '';
      this.cards = '';


      this.cardDismissible = '';
      this.cardHead = '';
      this.cardBody = '';
      this.cardFoot = '';


      this.debug = '';
    })();
  })();


  let innerContent = '';
  if (settings.cardContent || settings.cardContent != null) {
    const setTemplate = () => {
      const type = {
        partial: `{{> ${settings.partialName} }}`,
        markdown: '{{{content.markdown}}}',
        default: settings.cardContent,
      };
      return (type[settings.dynamicContent] || type.default);
    };

    const templateString = setTemplate();
    const partialTemplate = Handlebars.compile(templateString);
    innerContent = getDynamicContent(settings.card, jcrContexts, partialTemplate);
  }


  let footerContent = '';
  settings.footerData.forEach((item) => {

    const elementType = item.elementType ? item.elementType : 'a';


    const elementTypeClass = (elementType === 'button')
      ? 'spa-btn spa-btn--link'
      : '';


    const typeAttr = (elementType === 'button')
      ? 'type="button"'
      : '';


    const className = item.class
      ? `class="spa-card__foot-link ${elementTypeClass} ${item.class}"`
      : `class="spa-card__foot-link ${elementTypeClass}"`;

    const id = item.id
      ? `id="${item.id}"`
      : '';

    const URL = item.URL
      ? `href="${item.URL}"`
      : '';

    const label = item.ariaLabel
      ? `aria-label="${item.ariaLabel}"`
      : '';


    if (item.content) {
      footerContent += `
      <${elementType} ${typeAttr} ${className} ${id} ${URL} ${label}>
        ${item.content}
      </${elementType}>
      `;
    }
  });



  if (settings.dismissible) {
    settings.partials.cardDismissible += `
      <button
        class="spa-card__dismissible spa-icon icon-close ${settings.headerIcon} ${settings.dismissibleClass}"
        ${settings.dismissibleDescribedBy
          ? `aria-describedby="${settings.dismissibleDescribedBy}"`
          : `aria-label="${settings.dismissibleADA}"`
        }
        type="button"
      ></button>
    `;
  }

  settings.partials.cardHead += `
    <div class="spa-card__head ${settings.headerClass}">
      ${(settings.dismissible === false && settings.dismissibleADA !== false)
        ? `
          <div class="spa-card__ada-msg ada-hidden" tabindex="-1">${settings.dismissibleADA}</div>
        `
        : ''
      }
      <div class="spa-card__head-wrapper ${settings.headerSkin}">
        ${settings.title
          ? `
            <${settings.titleTag} ${settings.titleID ? `id="${settings.titleID}"` : ''} class="spa-card__title ${settings.headerTitleClass}">
              ${settings.title}
            </${settings.titleTag}>
          `
          : ''
        }
        ${settings.partials.cardDismissible}
      </div>
    </div>
  `;


  if (!settings.dismissible && !settings.title) {
    settings.partials.cardHead = `<div class="spa-card__ada-msg ada-hidden" tabindex="-1">${settings.dismissibleADA}</div>`;
  }

  settings.partials.cardBody += `
    <div ${settings.bodyID ? `id="${settings.bodyID}"` : ''} class="spa-card__body">
      ${innerContent}
    </div>
  `;

  settings.partials.cardFoot += footerContent
    ? `
        <div 
          class="spa-card__foot spa-card__foot-${settings.footerLayoutClass}"
          ${settings.footerLayoutDataAttr}
          ${settings.footerStackedDesktop}
          ${settings.footerStackedTablet}
          ${settings.footerStackedMobile}
        >
          ${footerContent}
        </div>
      `
    : '';



  settings.partials.cards += `
    <div ${settings.id} ${settings.class}>
      ${settings.layerStartADA
        ? `
          <div
            class="
              spa-card__ada-msg
              spa-card__ada-msg-layer-start
              ${settings.layerStartADAShowFocus}
              ada-hidden
            "
            tabindex="-1"
          >${settings.layerStartADA}</div>
        `
        : ''
      }
      ${settings.partials.cardHead}
      ${settings.partials.cardBody}
      ${settings.partials.cardFoot}
      ${settings.layerEndADA
        ? `
          <div
            class="
              spa-card__ada-msg
              spa-card__ada-msg-layer-end
              ${settings.layerEndADAShowFocus}
              ada-hidden
            "
            tabindex="-1"
          >${settings.layerEndADA}</div>
        `
        : ''
      }
    </div>
  `;



  settings.partials.debug += `
    <div ${settings.getID ? `id="${settings.getID}"` : ''} style="display: none;">
      ${JSON.stringify(settings, null, 4).replace(/\\"/g, '\'')}
    </div>
  `;



  settings.partials.cardWrapper += `
    ${settings.debug ? settings.partials.debug : ''}
    ${settings.partials.cards}
  `;



  return new Handlebars.SafeString(settings.partials.cardWrapper); 
}





const helpers = {






  cardHelper: function cardHelper(jcr, ...args) {
    return createCard(jcr, args);
  },
  cardUtility: function cardUtility(jcr, ...args) {
    return createCard(jcr, args);
  },
};





class cardHelper {






  static register(Handlebars) {
    Object.keys(helpers).forEach((key) => {
      Handlebars.registerHelper(key, helpers[key]);
    });
  }







  static render(options, ...args) {
    return helpers.cardHelper(options, args);
  }
}

module.exports = cardHelper;
